import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=6cfd73b0&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VDivider,VSheet})
